import { jwtDecode } from 'jwt-decode';

/**
 * Valida si un token JWT es válido y no ha expirado
 * @param {string} token - El token JWT a validar
 * @returns {Object} - Objeto con información de validación
 */
export const validateToken = (token) => {
  // Verificar que el token existe
  if (!token) {
    return {
      isValid: false,
      error: 'No hay token de autenticación',
      shouldLogout: true
    };
  }

  // Verificar que el token es una cadena
  if (typeof token !== 'string') {
    return {
      isValid: false,
      error: 'Token debe ser una cadena de texto',
      shouldLogout: true
    };
  }

  // Verificar formato JWT (3 partes separadas por puntos)
  const tokenParts = token.split('.');
  if (tokenParts.length !== 3) {
    return {
      isValid: false,
      error: 'Token malformado: debe tener 3 partes separadas por puntos',
      shouldLogout: true
    };
  }

  // Intentar decodificar el token
  try {
    const decoded = jwtDecode(token);
    
    // Verificar que tiene las propiedades necesarias
    if (!decoded || typeof decoded !== 'object') {
      return {
        isValid: false,
        error: 'Token decodificado inválido',
        shouldLogout: true
      };
    }

    // Verificar expiración
    if (!decoded.exp) {
      return {
        isValid: false,
        error: 'Token no tiene fecha de expiración',
        shouldLogout: true
      };
    }

    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      return {
        isValid: false,
        error: 'Token expirado',
        shouldLogout: true,
        decoded
      };
    }

    // Token válido
    return {
      isValid: true,
      decoded,
      error: null,
      shouldLogout: false
    };

  } catch (error) {
    console.error('Error decodificando token:', error);
    return {
      isValid: false,
      error: 'Error decodificando token: ' + error.message,
      shouldLogout: true
    };
  }
};

/**
 * Obtiene y valida el token del localStorage
 * @returns {Object} - Resultado de la validación
 */
export const getAndValidateToken = () => {
  const token = localStorage.getItem('token');
  return validateToken(token);
};

/**
 * Limpia la sesión del usuario
 */
export const clearUserSession = () => {
  console.log('Limpiando sesión del usuario');
  localStorage.clear();
  sessionStorage.clear();
  
  // Redirigir al login si estamos en una página protegida
  // Excluir rutas públicas de registro
  const publicRoutes = [
    '/login', 
    '/', 
    '/registro', 
    '/registro-gratuito', 
    '/registro-pagado',
    '/registro-gratuito-usuario',
    '/registro-pagado-usuario',
    '/registro-afiliado',
    '/registro-afiliado-epayco',
    '/autorizaciondatos',
    '/autorizaciondatosm',
    '/terminos-y-condiciones',
    '/cita-temporal',
    '/video-call-droxy',
    '/oauth/google/callback',
    '/oauth/linkedin/callback'
  ];
  
  const currentPath = window.location.pathname;
  const isPublicRoute = publicRoutes.includes(currentPath) || 
                       currentPath.startsWith('/cita-temporal/') ||
                       currentPath.startsWith('/video-call-droxy/') ||
                       currentPath.startsWith('/oauth/');
  
  if (!isPublicRoute) {
    window.location.href = '/login';
  }
};

/**
 * Hook para manejar tokens inválidos
 * @param {Object} validationResult - Resultado de validateToken
 */
export const handleInvalidToken = (validationResult) => {
  if (validationResult.shouldLogout) {
    console.error('Token inválido:', validationResult.error);
    clearUserSession();
  }
}; 